import { Dispatch } from '@reduxjs/toolkit';
import { FormInstance } from 'antd/lib/form';
import { validateForm } from '@xbcb/ui-utils';
import {
  AdditionalFormError,
  NamePath,
  ValidationErrorType,
} from '@xbcb/ui-types';
import { setValidationErrors } from 'actions/validation';
import { isHydraLineItemValidationEnabled } from 'featureFlags';

export const validateEntryForAoiOriginalBooking = async ({
  form,
  record,
  dispatch,
  currentUserId,
}: {
  form: FormInstance;
  record: any;
  dispatch: Dispatch;
  currentUserId?: string;
}): Promise<boolean> => {
  const additionalErrors: AdditionalFormError[] = [];
  const validateFields: NamePath[] = [];
  record?.invoices?.forEach((invoice: any, invoiceIndex: number) => {
    invoice.products?.forEach((product: any, productIndex: number) => {
      if (!product?.product?.clientIdentifier && !product?.clientIdentifier) {
        additionalErrors.push({
          title: 'SKU missing',
          type: ValidationErrorType.MISSING_FIELD,
          path: ['invoices', invoiceIndex, 'products', productIndex, 'product'],
          messages: [],
        });
      }

      if (isHydraLineItemValidationEnabled) {
        const productNamePath = [
          'invoices',
          invoiceIndex,
          'products',
          productIndex,
        ];
        const requiredPlFields: Array<{
          value: unknown;
          path: NamePath;
        }> = [
          {
            value: product?.cartonCount,
            path: [...productNamePath, 'cartonCount'],
          },
          {
            value: product?.grossWeight?.value,
            path: [...productNamePath, 'grossWeight', 'value'],
          },
          {
            value: product?.netWeight?.value,
            path: [...productNamePath, 'netWeight', 'value'],
          },
          {
            value: product?.grossVolume?.value,
            path: [...productNamePath, 'grossVolume', 'value'],
          },
        ];
        requiredPlFields.forEach(({ value, path }) => {
          validateFields.push(path);
          if (value === undefined || value === null || value === '') {
            additionalErrors.push({
              title: 'AMP2.0 required field missing',
              type: ValidationErrorType.MISSING_FIELD,
              path,
              messages: [],
            });
          }
        });
      }
    });
  });
  if (additionalErrors.length) {
    additionalErrors.push({
      title: 'Please fix errors for AMP2.0 original booking',
      messages: [],
    });
  }
  return validateForm({
    form,
    additionalErrors: additionalErrors.length ? additionalErrors : undefined,
    validateFields: validateFields.length ? validateFields : undefined,
    skipValidateFields: true,
    currentUserId,
    setErrorState: (errors: any) =>
      dispatch(
        setValidationErrors({
          recordId: record.id,
          validationResult: errors,
        }),
      ),
  });
};
